/*
 * @Author: wilson 1207014631@qq.com
 * @Date: 2023-09-19 12:34:47
 * @LastEditors: wilson 1207014631@qq.com
 * @LastEditTime: 2023-09-20 18:47:59
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import 'babel-polyfill'
import '@/assets/css/reset.css'
import 'element-ui/lib/theme-chalk/display.css';
import Vant from 'vant';
import 'vant/lib/index.css';
// import './utils/flexble.js'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
